/**
 * @description 助力
 * @author Kody
 * @date 2019-08-08
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    privilege_type: string;
}
interface IOutput {
    status: number;
}

export const toExchangePrivilege = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.EXCHANGE_PRIVILEGE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
